import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../theme/modernTheme';

export default function WhatsAppTemplateDeleteContent() {
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Typography
        variant="body2"
        sx={{
          color: colors.text.secondary,
          mb: 2,
          fontSize: '0.875rem',
          lineHeight: 1.6,
        }}>
        This action cannot be undone. Are you sure you want to proceed?
      </Typography>
      
      <Typography
        variant="body2"
        sx={{
          color: colors.text.secondary,
          mb: 1.5,
          fontSize: '0.875rem',
          lineHeight: 1.6,
        }}>
        Below are impacts of deletion:
      </Typography>
      
      <Box component="ul" sx={{ m: 0, pl: 2.5, color: colors.text.secondary }}>
        <Typography
          component="li"
          variant="body2"
          sx={{
            fontSize: '0.8rem',
            mb: 1,
            lineHeight: 1.6,
          }}>
          Deleting a template by name often removes all language versions associated with that name.
        </Typography>
        <Typography
          component="li"
          variant="body2"
          sx={{
            fontSize: '0.8rem',
            mb: 1,
            lineHeight: 1.6,
          }}>
          Once an approved template name is deleted, it cannot be reused for a specific period (commonly 30 days).
        </Typography>
        <Typography
          component="li"
          variant="body2"
          sx={{
            fontSize: '0.8rem',
            mb: 1,
            lineHeight: 1.6,
          }}>
          Any messages sent using the template before deletion may still be delivered within a 30-day window.
        </Typography>
        <Typography
          component="li"
          variant="body2"
          sx={{
            fontSize: '0.8rem',
            lineHeight: 1.6,
          }}>
          The template cannot be restored once deleted.
        </Typography>
      </Box>
    </Box>
  );
}
